// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/WhatsNewModal.scss
// module id = 1268
// module chunks = 0